// The one sealed request/reply every module uses: a JSON body sealed toward
// the named service, the reply opened and parsed. No module publishes a body
// in clear (decision 0007).
import { utf8Decode, utf8Encode } from "./encoding.js";
/**
 * request sends body as JSON, sealed toward the named service, on subj, and
 * returns the opened reply parsed as JSON. An undefined body is sent empty,
 * sealed like any other.
 */
export async function request(nc, caller, service, subj, body, opts) {
    const data = body === undefined ? new Uint8Array(0) : utf8Encode(JSON.stringify(body));
    const reply = await caller.request(nc, service, subj, data, opts);
    try {
        return JSON.parse(utf8Decode(reply.data));
    }
    catch (err) {
        throw new Error(`request: ${subj}: reply is not JSON`, { cause: err });
    }
}
//# sourceMappingURL=request.js.map